import React from 'react';

import { Alert, AlertHeading, AlertMessage } from '@components/common';

interface BaseApprovalAlertProps {
  heading: string;
  message: string;
}

export const BaseApprovalAlert: React.FC<BaseApprovalAlertProps> = ({ heading, message }) => {
  return (
    <Alert className='my-4' type='warning'>
      <>
        <AlertHeading>{heading}</AlertHeading>
        <AlertMessage>{message}</AlertMessage>
      </>
    </Alert>
  );
};
